export const env: { [s: string]: (string | null); } = {
  'npm_package_version': '2.0.0-beta-035'
};
